import type * as d3 from "d3";
import type {MatKpiTreeData} from "../../../services/ApiTypes.ts";
import type {TreeDataType} from "../../../components/visualization/collapsible-indent-tree/CollapsibleIndentTree.tsx";

type Filter = undefined | ((d: d3.HierarchyNode<TreeDataType<MatKpiTreeData>>) => boolean);
export const CDT_FILTERS: Filter[] = [
    undefined,
    d => d?.data?.values.spend >= 1_000,
    d => d?.data?.values.spend >= 1_000_000,
    d => d?.data?.values.distinct_suppliers >= 5,
    d => d?.data?.values.parts >= 100,
]
